import { ElementRef, Directive, Input, Output, EventEmitter, OnInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import * as _ from 'lodash';
import * as moment from 'moment';
import { DeviceService } from 'app/shared/services/device.service';
import { GxConstants } from 'app/shared/constants/gx.constants';
declare const $: any;
@Directive({
    selector: '[pickadate2]'
})
export class PickadateDirective implements OnInit, OnDestroy, OnChanges {
    @Output() valueChange = new EventEmitter();

    @Input() minDate: Date;
    @Input() operatingDays: Array<number | boolean>;
    @Input() value: Date;
    @Input() format = 'ddd, d mmm yyyy';
    @Input() isDisabled: boolean;
    @Input() container: string;

    private $input: any;
    private _picker: Pickadate;
    private element: ElementRef;

    constructor(private _element: ElementRef,
        private deviceService: DeviceService) {
        this.element = _element;
    }

    ngOnInit() {
        const daysToEnable = _.clone(this.operatingDays);
        if (!!daysToEnable) {
            daysToEnable.unshift(true);
        }
        const opts = {
            format: this.format,
            min: this.minDate,
            selectYears: true,
            selectMonths: true,
            disable: daysToEnable,
            container: this.container
        };
        this.$input = $(this._element.nativeElement).pickadate(opts);
        this._picker = this.$input.pickadate('picker')
            .on('open', this.onPickerOpen);
        this._picker = this.$input.pickadate('picker')
            .on('close', this.onPickerClose);

        this.setValue();
    }

    ngOnDestroy() {
        this._picker.off('close').stop();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['isDisabled'] && !changes['isDisabled'].isFirstChange()) {
            if (changes['isDisabled'].currentValue) {
                this.value = null;
                this._picker.set('clear');
                this.setValue();
                this.$input.attr('disabled', true);
            } else {
                this.$input.attr('disabled', false);
            }

        }
        if (!!changes['value'] && !this.isDisabled) {
            if (!!changes['value'].isFirstChange()) {
                return;
            }
            this.value = changes['value'].currentValue;
            this.setValue();
        }
    }

    private setValue() {
        let d = typeof this.value === 'string' && this.value === GxConstants.MIN_DATE ? null : this.value;
        d = !!d ? moment(this.value).toDate() : null;
        this._picker.set({ 'select': d });

    }

    private onPickerOpen = () => {
        if (!this.deviceService.IsMobile()) {
            $('.picker__holder').on('click', (event) => {
                if ($(event.target).hasClass('picker__holder')) {
                    this.onPickerClose();
                }
            });
            const inputGroup = $(this.element.nativeElement).parent().parent().parent();
            inputGroup.addClass('input--active');
            $('header').addClass('modal-active');
            inputGroup.append('<div class=\'express-overlay\'></div>');
            /*
            $(this.element.nativeElement).parent().find('.picker__frame').css(
                {
                    top: inputGroup.find('.picker').offset().top - $(window).scrollTop(),
                    left: inputGroup.find('.picker').offset().left,
                    bottom: 'auto',
                    right: 'auto'
                });

            this.moveIntoViewport(inputGroup.find('.picker').offset().left, $(this.element.nativeElement).parent().find('.picker__frame'));
             */
        }
    }

    private onPickerClose = () => {
        if (!this.deviceService.IsMobile()) {
            $('.express-overlay').remove();
            $('header').removeClass('modal-active');
            $(this.element.nativeElement).parent().parent().parent().removeClass('input--active');
        }
        const str = this._picker.get('select', 'yyyy-mm-dd');
        this.valueChange.emit(str);
        this._picker.close();
    }

    private moveIntoViewport(leftOffset: number, element: any) {
        const elementLeft = leftOffset;
        const elementRight = elementLeft + $(element).outerWidth();
        const viewportLeft = 0;
        const viewportRight = viewportLeft + $(window).width();

        if (elementRight > viewportRight) {
            element.css({
                left: leftOffset - (elementRight - viewportRight)
            });
        }
    }

    openPickaDate() {
        this._picker.open();
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/pick-a-date/pickadate.directive.ts